export const getLabel = ({
  isOneFilterSelected,
  isSubscribed,
  shortDisplayName,
  name,
  articleType,
  isCompanyPage,
}: {
  isOneFilterSelected: boolean,
  isSubscribed: boolean,
  shortDisplayName: string,
  name: string,
  articleType: string,
  isCompanyPage: boolean,
}) => {
  if (isCompanyPage) {
    return `Subscribe${ isSubscribed ? 'd' : '' } to ${ name } 
          Commentary & Deal Flow Email Alerts`;
  }

  if (!isOneFilterSelected) {
    return 'Select 1 credit product/region to manage email alerts';
  }

  return `Subscribe${ isSubscribed ? 'd' : '' } to ${ shortDisplayName } ${ name } 
          ${ articleType } Email Alerts`;
};
